export default __webpack_public_path__ + "static/logo-horizontal-6fab03ca9f85a2f39032d22a4b98711a.svg";